export enum eEndorsements {
  _4_06 = '_4_06',
  _4_1_06 = '_4_1_06',
  _5_06 = '_5_06',
  _5_1_06 = '_5_1_06',
  _6_06 = '_6_06',
  _6_2_06 = '_6_2_06',
  _7_06 = '_7_06',
  _7_1_06 = '_7_1_06',
  _8_1_06 = '_8_1_06',
  _9_06 = '_9_06',
  _10_06 = '_10_06',
  _12_06 = '_12_06',
  _13_1_06 = '_13_1_06',
  _14_06 = '_14_06',
  _14_1_06 = '_14_1_06',
  _14_3_06 = '_14_3_06',
  _22_06 = '_22_06',
  _30_06 = '_30_06',
  ChangeOfPartners = 'ChangeOfPartners',
  Contiguity = 'Contiguity',
  NSE = 'NSE',
  Residential = 'Residential',
  RevolvingCredit = 'RevolvingCredit',
  Survey = 'Survey',
  WaiverOfArbitration = 'WaiverOfArbitration',
  _T_36 = '_T_36',
  _T_19 = '_T_19',
  _T_28 = '_T_28',
  _T_17 = '_T_17',
  _T_33 = '_T_33',
  _T_31 = '_T_31',
  _T_42 = '_T_42',
  _T_42_1 = '_T_42_1',
  _T_30 = '_T_30',
  _R_24 = '_R_24',
}
